module.exports = __webpack_public_path__ + "media/images/footerbg-0047e201af908b6a466c868172bdc1da.png";